import { useGlobalContext } from "../context";
import CartItem from "./CartItem";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";

function Cart() {
  const { cartCount, cartItems, setCartItems, setCartCount } =
    useGlobalContext();

  /* Total total cart value */
  let totalAmount = cartItems.reduce((acc, curr) => {
    acc += parseFloat(curr.price);
    return acc;
  }, 0);

  /**
   * @desc Fetch cart items
   */
  const fetchCartItems = async () => {
    const cartUrl = process.env.REACT_APP_API_URL + "/cart";

    if (JSON.parse(localStorage.getItem("ekartToken"))) {
      const response = await axios.get(cartUrl, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("ekartToken")).token,
        },
      });

      setCartItems(response.data.items);
      setCartCount(response.data.items.length);
    }
  };

  useEffect(() => {
    fetchCartItems();
  }, []);

  return (
    <div
      className="container"
      style={{ marginTop: "8rem", marginBottom: "1rem" }}
    >
      <div className="d-flex justify-content-center">
        <p className="fw-bold fs-3">You have {cartCount} items in your cart</p>
      </div>
      <hr className="bg-danger border-2 border-top border-dark" />
      {cartItems.map((item) => {
        return <CartItem key={item._id} {...item} />;
      })}
      <div
        className="d-flex flex-wrap justify-content-around"
        style={{
          margin: "0 auto",
          border: "1px solid lightgray",
          padding: "1rem",
        }}
      >
        {/* <p className="fs-3">Total: {totalAmount}</p> */}
        {totalAmount > 0 ? (
          <button className="btn btn-warning" style={{ borderRadius: "3rem" }}>
            <Link
              to="/checkout"
              style={{ textDecoration: "none", color: "#333" }}
            >
              Confirm your order
            </Link>
          </button>
        ) : (
          <button
            className="btn btn-warning"
            style={{ borderRadius: "3rem" }}
            disabled
          >
            Confirm your order
          </button>
        )}
      </div>
    </div>
  );
}

export default Cart;
